import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, ButtonBase, Typography } from '@material-ui/core';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import useSiteCopySelector from 'components/useSiteCopySelector';
import CloseIcon from 'containers/TopicCenter/images/close.svg';
import MenuIcon from 'containers/TopicCenter/images/menu.svg';
import Overlay from './MobileTaggedTopicsOverlay';

const useStyles = makeStyles(() => ({
  root: {
    padding: 18,
  },
  container: {
    height: 50,
    border: '1px solid #E3E3E3',
    borderRadius: 3,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 12,
  },
  icon: {
    marginRight: 23,
  },
  title: {
    fontSize: 17,
    color: '#01619B',
    lineHeight: '43px',
  },
  dialogRoot: {
    marginTop: 220,
    zIndex: '9 !important',
    '& .MuiDialog-paper': {
      boxShadow: 'none',
    },
  },
  contentRoot: {
    padding: 25,
  },
  selected: {
    display: 'flex',
    '& img': {
      marginRight: 17,
    },
    '& p': {
      fontSize: 16,
      fontFamily: 'MadaBold',
    },
  },
}));

function MobileTaggedTopics({ data, position }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const offsetTop = useRef(0);
  const classes = useStyles({ offsetTop: offsetTop.current });
  const [resourceItemPageSiteCopy] = useSiteCopySelector([
    'resource-item-page',
  ]);
  const handleBtnClick = event => {
    const viewportRect = event.currentTarget.getBoundingClientRect();
    offsetTop.current = viewportRect.top;

    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const open = Boolean(anchorEl);
  if (_isEmpty(data)) return null;
  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} container className={classes.container}>
        <div className={classes.selected}>
          <Typography>
            {_get(resourceItemPageSiteCopy, 'pageCopy.taggedTopicsHeader')}
          </Typography>
        </div>
        <div>
          <ButtonBase onClick={handleBtnClick}>
            <img src={open ? CloseIcon : MenuIcon} alt="" />
          </ButtonBase>
        </div>
      </Grid>
      {open && (
        <Overlay
          anchorEl={anchorEl}
          data={data}
          offsetTop={offsetTop.current}
          position={position}
        />
      )}
      {/* <Dialog
        fullScreen
        open={open}
        disableBackdropClick
        hideBackdrop
        classes={{
          root: classes.dialogRoot,
        }}
      >
        <Grid container className={classes.contentRoot}>
          {data.map((el, index) => (
            <TaggedTopicInfo data={el} key={_get(el, 'fields.slug', index)} />
          ))}
        </Grid>
      </Dialog> */}
    </Grid>
  );
}

MobileTaggedTopics.propTypes = {
  data: PropTypes.array,
  position: PropTypes.string,
};

MobileTaggedTopics.defaultProps = {
  position: null,
};

export default React.memo(MobileTaggedTopics);
